import flow from 'lodash/flow';
import { AnalyticsSubject, withFireUiAnalytics } from '@atlassian/jira-analytics-web-react/src';
import ChartItems, { type APIProps } from './view';

export default flow(
	AnalyticsSubject('issue'),
	withFireUiAnalytics({
		onItemClick: 'issue',
	}),
)(ChartItems);

export type { APIProps };
